import React from "react";
import { FiClock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const TrialTimer = ({ expiryTimestamp }) => {
  const navigate = useNavigate();

  if (!expiryTimestamp) return null;

  const calculateTimeLeft = () => {
    const end = new Date(expiryTimestamp * 1000); 
    const now = new Date();
    const difference = end - now;

    // 1. Jeśli czas minął -> null
    if (difference <= 0) return null;

    // 2. NOWY WARUNEK: Jeśli zostało więcej niż 72h -> null
    const hoursTotal = difference / (1000 * 60 * 60);
    if (hoursTotal > 72) return null;

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);

    return { days, hours, minutes };
  };

  const timeLeft = calculateTimeLeft();
  
  // Jeśli funkcja zwróciła null (bo czas minął LUB jest > 72h), komponent się nie pokaże
  if (!timeLeft) return null;

  let timeString = "";
  if (timeLeft.days > 0) {
    timeString = `${timeLeft.days}d ${timeLeft.hours}h`;
  } else if (timeLeft.hours > 0) {
    timeString = `${timeLeft.hours}h ${timeLeft.minutes}m`;
  } else {
    timeString = `${timeLeft.minutes} min`;
  }

  return (
    <div 
      onClick={() => navigate('/upgrade')}
      className="mt-4 w-full flex items-center justify-center gap-1.5 cursor-pointer group opacity-90 hover:opacity-100 transition-opacity"
      role="button"
      title="Zobacz ceny"
    >
      <FiClock className="w-3.5 h-3.5 text-[#233855]" />

      <span className="text-[10px] font-bold uppercase tracking-widest text-[#233855] group-hover:underline underline-offset-2 decoration-[#233855]/30">
        Koniec darmowego dostępu za {timeString} · Zobacz ceny
      </span>
    </div>
  );
};

export default TrialTimer;